'use strict'

const lazyLoad = function () {

    // private methods

    const lazyLoad = (picture) => {
        const img = picture.querySelector('img');
        const sources = picture.querySelectorAll('source');

        sources.forEach((source) => {
            source.srcset = source.dataset.srcset;
        });
        img.src = img.dataset.src;
    };


    // public methods

    /**
    * @ngdoc method
    * @name initializeLazyLoad
    **/
    const initializeLazyLoad = function () {
        if (window.imgObserver) {
            addImages('.lazy-picture');
            return;
        }

        window.imgObserver = new IntersectionObserver((entries, self) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    lazyLoad(entry.target);
                    self.unobserve(entry.target);
                }
            });
        });

        addImages('.lazy-picture');
    };

    const addImages = function (selector) {
        if (!window.imgObserver) {
            initializeLazyLoad();
            return;
        }

        document.querySelectorAll(selector).forEach((picture) => {
            window.imgObserver.observe(picture);
        });
    };

    // Return an object exposing the public items
    return {
        initialize: initializeLazyLoad,
        addImages: addImages
    };
};

window.lazyLoad = lazyLoad();
module.exports = lazyLoad();
